import { AppEnvironment, FirebaseEnvironment, StoreURL } from './entities/app_envirinment'

const firebase: FirebaseEnvironment = {
    apiKey: 'AIzaSyBWdTyeEv9ZXn0Uc47KF5Xe6kiZo8DxV-0',
    authDomain: 'mc-app-genjirou-dev.firebaseapp.com',
    projectId: 'mc-app-genjirou-dev',
    storageBucket: 'mc-app-genjirou-dev.firebasestorage.app',
    messagingSenderId: '317440197576',
    appId: '1:317440197576:web:ed86560cb160c5ca0e36fd',
    measurementId: 'G-EYXP864Y2Q',
}

const storeURL: StoreURL = {
    ios: 'https://apps.apple.com/app/6756248869',
    android: 'https://play.google.com/store/apps/details?id=jp.genjirou.members',
}

export const environment: AppEnvironment = {
    production: false,
    brandCode: 'genjirou',
    env: 'dev',
    firebase,
    hostingBaseURL: 'https://app-dev.genjirou.jp',
    appScheme: 'genjirou-monogatari-app-dev',
    storeURL,
}
